import { GetQuizOptionsRequest, GetQuizOptionsResponse } from '../dto/user-words';
import { httpArg, httpPost, httpRoute, optionalHttpUserId } from '../infrastructure/http/http-decorators';

/**
 * Service for quiz operations.
 * Provides quiz options/questions for word learning.
 */
@httpRoute('/api/user-words')
export abstract class IQuizzService {
	/**
	 * Get quiz options for a word or set of words
	 */
	@httpPost('get-quiz-options')
	getQuizOptions(
		@httpArg('request') request: GetQuizOptionsRequest,
		@optionalHttpUserId() userId?: string
	): Promise<GetQuizOptionsResponse> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}
}
